export default "__VITE_ASSET__BpY71Scp__"